export default __webpack_public_path__ + "static/media/Observador.651bc828.svg";